module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card', [_c('div', {
    staticClass: "property-flex",
    on: {
      "click": _vm.onClick
    },
    slot: "content"
  }, _vm._l((_vm.fields), function(field) {
    return _c('div', {
      key: field.name,
      staticClass: "vux-1px-l vux-1px-r"
    }, [_c('span', [_vm._v(_vm._s(field.name))]), _vm._v(" "), _c('br'), _vm._v(_vm._s(field.value || '-') + "\n    ")])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-115b99df"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/HCard.vue
// module id = 538
// module chunks = 1